import { Col } from 'antd';
import * as React from 'react';
import MobileFooter from '../../../Mobile/MobileFooter/MobileFooter';
import MobileHeader from '../../../Mobile/MobileHeader/MobileHeader';
import './PublicMobileLayout.scss';

const PublicMobileLayout = (props) => {
  const { children } = props;
  return (
    <div className='public-mobile-layout'>
      <Col>
        <MobileHeader />
        <div className='layout-child'>{children}</div>
      </Col>
      <MobileFooter />
    </div>
  );
};

export default PublicMobileLayout;
